import toolsClient from "@/api/toolsClient"
import { MULTIPART_HEADERS } from "@/api/apiUtils"

const getAll = async () => {
  const { data } = await toolsClient.get("/portal/dashboard/banners")

  return Array.isArray(data) ? data : []
}

const getForAccount = async (accountKey) => {
  const { data } = await toolsClient.get(`/accounts/${encodeURIComponent(accountKey)}/dashboardBanner`)

  return data || null
}

const update = async (banner, file) => {
  const formData = new FormData()

  formData.append("banner", JSON.stringify(banner))

  if (file) {
    formData.append("file", file)
  }

  const { data } = await toolsClient.post("/portal/dashboard/banner", formData, MULTIPART_HEADERS)

  return data
}

const remove = async (planType = null) => {
  const { data } = await toolsClient.delete("/portal/dashboard/banner", { params: { planType } })

  return data
}

export default {
  getAll,
  getForAccount,
  update,
  remove,
}
